const appRoutes = {
  login: "/login",
  notAuthorized: "/noaccess",
  patientDetails: "/patient/patientDetails",
  consultNotes: "/patient/consultNotes",
  medicalInfo: "/patient/medicalInfo",
  accessLogs: "/patient/accessLogs",
  tempMedicalCertificate: "/templates/medicalcertificate",
  carerMedicalCertificate: "/templates/carercertificate",
  tempPrescription: "/templates/prescription",
  tempReferralLetter: "/templates/referralLetter",
  tempPathologyRequest: "/templates/pathologyRequest",
  tempRadiologyRequest: "/templates/radiologyRequest",
  tempGeneralLetter: "/templates/generalLetter",
  tempCosmeticInjectables: "/templates/cosmeticInjectables",
  tempIntravenousTherapy: "/templates/intravenousTherapy",
  generatePDF: "/pdf/generate"
};

export default appRoutes;
